import React from 'react';
import { Badge } from './Badge';
interface ActivityCardProps {
  title: string;
  subtitle: string;
  image: string;
  tag: string;
  date: string;
}
export function ActivityCard({
  title,
  subtitle,
  image,
  tag,
  date
}: ActivityCardProps) {
  return <div className="flex flex-col bg-white rounded-2xl overflow-hidden shadow-sm border border-gray-100" data-id="element-18">
      <div className="relative h-48" data-id="element-19">
        <img src={image} alt={title} className="w-full h-full object-cover" data-id="element-20" />
        <div className="absolute top-3 left-3" data-id="element-21">
          <Badge className="bg-[#66CADA] hover:bg-[#2BAABD] border-none text-white px-3 py-1 rounded-lg" data-id="element-22">
            {tag}
          </Badge>
        </div>
      </div>
      <div className="p-4 flex flex-col gap-1" data-id="element-23">
        <h3 className="text-lg font-bold text-[#333333] line-clamp-1" data-id="element-24">
          {title}
        </h3>
        <p className="text-sm text-[#666666] line-clamp-1" data-id="element-25">{subtitle}</p>
        <div className="mt-2 text-xs text-[#999999]" data-id="element-26">{date}</div>
      </div>
    </div>;
}